import { render, staticRenderFns } from "./com-schannel.vue?vue&type=template&id=48c67c91&scoped=true"
import script from "./com-schannel.vue?vue&type=script&lang=js"
export * from "./com-schannel.vue?vue&type=script&lang=js"
import style0 from "./com-schannel.vue?vue&type=style&index=0&id=48c67c91&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c67c91",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48c67c91')) {
      api.createRecord('48c67c91', component.options)
    } else {
      api.reload('48c67c91', component.options)
    }
    module.hot.accept("./com-schannel.vue?vue&type=template&id=48c67c91&scoped=true", function () {
      api.rerender('48c67c91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/components/com-schannel.vue"
export default component.exports